import { Injectable } from '@angular/core'
import { Observable, from } from 'rxjs'

import { Sample } from '../interfaces/sample.interface'
import { OfflineResourceService } from './offline/offline-resource.service'

@Injectable({
  providedIn: 'root'
})
export class SampleService {

  constructor(private offlineResourceService: OfflineResourceService) {}

  show(id: number | string): Observable<Sample> {
    return from(this.offlineResourceService.getSample(id))
  }
}
